if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const productInfo=this.closest('product-info');
        if(productInfo?.dataset?.cnmExcludedBentoVariants?.split('|').includes(String(this.variantIdInput.value))){
          this.handleErrorMessage((document.documentElement.lang === 'en' ? 'Bento Boxes are no longer available. Please choose another cake size.' : 'Les Bento Box ne sont plus proposés. Choisissez un autre format de gâteau.'));
          return;
        }
        if (this.closest('product-info')?.cnmLeadTimeValidate && !this.closest('product-info').cnmLeadTimeValidate()) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        for (const field of this.form.elements) {
          if (field.matches?.('[data-cnm-required]') && !field.reportValidity()) return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        const addons = Array.from(this.form.elements).filter(field => field.matches?.('[data-cnm-box],[data-cnm-addon]') && field.checked && !field.disabled);
        if (addons.length) {
          const mainId = formData.get('id');
          const quantity = Math.max(1, Number(formData.get('quantity') || 1));
          const combined = new FormData();
          for (const [name, value] of formData.entries()) {
            if (name.startsWith('properties[')) combined.append(name.replace(/^properties\[/, 'items[0][properties]['), value);
            else if (['id', 'quantity', 'selling_plan'].includes(name)) combined.append('items[0][' + name + ']', value);
            else combined.append(name, value);
          }
          combined.set('items[0][quantity]', String(quantity));
          addons.forEach((addon,index) => {
            const item=index+1;
            combined.set(`items[${item}][id]`, addon.dataset.addonVariant);
            combined.set(`items[${item}][quantity]`, String(quantity));
            combined.set(`items[${item}][parent_id]`, String(mainId));
            combined.set(`items[${item}][properties][Pour le produit]`, this.closest('product-info')?.querySelector('.product__title')?.textContent?.trim() || (document.documentElement.lang === 'en' ? 'Selected product' : 'Produit sélectionné'));
          });
          formData = combined;
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
